import script from "./ModalClient.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalClient.vue?vue&type=script&setup=true&lang=js"

import "./ModalClient.vue?vue&type=style&index=0&id=a7cb7142&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7cb7142"]])

export default __exports__